const e = {
  name: "NumberSixCircleFilled",
  dimensions: { width: 40, height: 40 },
  content: `
    <svg fill="none">
    <g clip-path="url(#clip0_12_1928)">
    <path d="M20 40.033C31.0457 40.033 40 31.0787 40 20.033C40 8.98726 31.0457 0.032959 20 0.032959C8.9543 0.032959 0 8.98726 0 20.033C0 31.0787 8.9543 40.033 20 40.033Z" fill="currentColor"/>
    <path d="M20 25.033C21.3807 25.033 22.5 23.9137 22.5 22.533C22.5 21.1522 21.3807 20.033 20 20.033C18.6193 20.033 17.5 21.1522 17.5 22.533C17.5 23.9137 18.6193 25.033 20 25.033Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M22.5 17.533C22.5 16.8699 22.2366 16.234 21.7678 15.7652C21.2989 15.2964 20.663 15.033 20 15.033C19.337 15.033 18.7011 15.2964 18.2322 15.7652C17.7634 16.234 17.5 16.8699 17.5 17.533V22.533" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_12_1928">
    <rect width="40" height="40" fill="white" transform="translate(0 0.032959)"/>
    </clipPath>
    </defs>
    </svg>
    `
};
export {
  e as NumberSixCircleFilled
};
